import LandingPage from '../components/LandingPage'

const index = () =>
  <LandingPage />

export default index
